import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35b8b9ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-default-wrapper" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("We’ve updated our")
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtitle-desc" }, "We’ve made some changes to clarify how we handle your data and deliver our services. To continue using our products, please review and accept the new terms.", -1))
const _hoisted_5 = {
  key: 0,
  class: "input-row"
}
const _hoisted_6 = { class: "input-wr w-100" }
const _hoisted_7 = { class: "input-box" }
const _hoisted_8 = ["checked"]
const _hoisted_9 = {
  class: "checkbox-label",
  for: "agree-terms-of-use"
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode("I have read and agree to ")
const _hoisted_11 = ["href"]
const _hoisted_12 = {
  key: 1,
  class: "input-row"
}
const _hoisted_13 = { class: "input-wr w-100" }
const _hoisted_14 = { class: "input-box" }
const _hoisted_15 = ["checked"]
const _hoisted_16 = {
  class: "checkbox-label",
  for: "privacy-policy"
}
const _hoisted_17 = /*#__PURE__*/_createTextVNode("I have read and agree to ")
const _hoisted_18 = ["href"]
const _hoisted_19 = { class: "controls" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = { class: "default-form" }
const _hoisted_22 = { class: "input-row" }
const _hoisted_23 = { class: "input-wr w-100" }
const _hoisted_24 = { class: "input-box" }
const _hoisted_25 = {
  key: 0,
  class: "error-box"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["AppModal"], {
    isOpen: $props.isOpen,
    onClose: _cache[4] || (_cache[4] = ($event: any) => ($setup.emits('close'))),
    "show-close": false,
    "allow-backdrop-click": false,
    "is-use-disable-scroll": false
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createElementVNode("h3", null, [
            _hoisted_2,
            _hoisted_3,
            _createTextVNode(_toDisplayString(!$setup.isActualPolicyAgreement && !$setup.isActualTermsAgreement ? "Privacy Policy and Terms of use" : !$setup.isActualPolicyAgreement ? 'Privacy Policy' : 'Terms of use'), 1)
          ]),
          _hoisted_4
        ]),
        _createElementVNode("form", {
          class: "default-form",
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
        }, [
          (!$setup.isActualTermsAgreement)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _withDirectives(_createElementVNode("input", {
                      class: "input",
                      id: "agree-terms-of-use",
                      type: "checkbox",
                      tabindex: "1",
                      checked: $setup.agreeTermsOfUse,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.agreeTermsOfUse) = $event))
                    }, null, 8, _hoisted_8), [
                      [_vModelCheckbox, $setup.agreeTermsOfUse]
                    ]),
                    _createElementVNode("label", _hoisted_9, [
                      _hoisted_10,
                      _createElementVNode("a", {
                        class: "link",
                        href: $setup.getTermsOfUseLink
                      }, "Terms of Use", 8, _hoisted_11)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (!$setup.isActualPolicyAgreement)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _withDirectives(_createElementVNode("input", {
                      class: "input",
                      id: "privacy-policy",
                      type: "checkbox",
                      tabindex: "2",
                      checked: $setup.agreePrivacyPolicy,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.agreePrivacyPolicy) = $event))
                    }, null, 8, _hoisted_15), [
                      [_vModelCheckbox, $setup.agreePrivacyPolicy]
                    ]),
                    _createElementVNode("label", _hoisted_16, [
                      _hoisted_17,
                      _createElementVNode("a", {
                        class: "link",
                        href: $setup.getPrivacyPolicyLink
                      }, "Privacy Policy", 8, _hoisted_18)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ], 32),
        _createElementVNode("div", _hoisted_19, [
          ($setup.loading)
            ? (_openBlock(), _createBlock($setup["PreLoader"], { key: 0 }))
            : (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "button default primary",
                type: "button",
                disabled: (!$setup.isActualTermsAgreement && !$setup.agreeTermsOfUse) || (!$setup.isActualPolicyAgreement && !$setup.agreePrivacyPolicy),
                onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.onUpdateTerms()))
              }, "I agree", 8, _hoisted_20))
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                ($setup.backErrorValue)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_25, _toDisplayString($setup.backErrorValue), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["isOpen"]))
}